module.exports = __webpack_public_path__ + "static/media/search.09aea0f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/search.svg
// module id = 54
// module chunks = 0